module.exports = __webpack_public_path__ + "static/img/dd01.dfa0541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dd01.png
// module id = G5K1
// module chunks = 0